import { SETTING_ELEMENTS } from '@/constants/elements/setting-elements';
import { SETTING_FORM_FIELDS } from '@/constants/elements/setting-form-field';
import { SETTING_ARTICLES } from '@/constants/modules/setting-articles';
import { SETTING_PRODUCTS } from '@/constants/modules/setting-products';
import { SETTING_COLLECTIONS } from '@/constants/modules/setting-collections';
import { SETTING_BOOSTER } from '@/constants/modules/setting-booster';

// TODO:
// type OB_TYPE_SETTING_GS_2 = {
//   gsId: string;
//   gsSettingGroup: string;
//   titleTag?: string;
//   isRenderColumn: boolean;
//   isSettingAdvand: boolean;
//   typeSetting?: string; // heading | paragraph | button | heading-paragraph
// };
export const SETTING_GLOBAL_STYLE: any = {
  // ========== ELEMENTS ==========
  ...SETTING_ELEMENTS,
  // ========== ARTICLES ==========
  ...SETTING_ARTICLES,
  // ========== PRODUCTS ==========
  ...SETTING_PRODUCTS,
  // ========== FORM_FIELDS ==========
  ...SETTING_FORM_FIELDS,
  // ========== COLLECTIONS ==========
  ...SETTING_COLLECTIONS,
  // ========== BOOSTER ==========
  ...SETTING_BOOSTER,
  // ========== THIRD PARTYS ==========
};
